import { UarmViewType, CardMetaItem, UarmCtrlComponentMetaParam, UarmCtrlComponentMetaParamsObj } from '@uarmSrc/types';
import { PropType } from 'vue';

/**
 * Используемый многими контролами параметр "Кастомный шаблон"
 */
export const customTemplate: UarmCtrlComponentMetaParam = {
	name: 'Кастомный шаблон',
	tip: 'Для кастомного форматирования используется синтаксис Handlebars. <a href="https://wiki.oooinex.ru/pages/viewpage.action?pageId=119933363">Документация в Wiki</a>',
	editType: 'customTemplateEditor',
};

/**
 * Параметры для всех контролов
 */
export const ctrlParamsForAll: UarmCtrlComponentMetaParamsObj = {
	extraDescr: {
		name: 'Подсказка (текст под полем)',
		editType: 'input',
	},
	isDefaultView: {
		name: 'Отображать по умолчанию',
		editType: 'checkbox',
		onlyForViewTypes: ['filter'],
	},
	/*
	TODO понять и описать разницу между isHidden и isInvisible
	оба параметра универсальные и обрабатываются вне контролов
	*/
	isInvisible: {
		name: 'isInvisible (скрытый контрол)',
		tip: 'Контрол не выводится на клиенте (в т.ч. в DOM) и не отправляется на сервер',
		editType: 'checkbox',
		// onlyForViewTypes: ['filter', 'list', 'card'], // исп. во всех viewTypes
	},
	isHidden: {
		name: 'isHidden',
		tip: 'Скрыть блок (в DOM дереве останется)',
		editType: 'checkbox',
		onlyForViewTypes: ['list', 'card'],
	},
};

/**
 * Типизированная замена миксину из _mixins.js
 */
export const ctrlProps4All = {
	/** Тип использования (фильтр/список/карточка) */
	view_type: {
		type: String as PropType<UarmViewType>,
	},
	/** Все поля данного АРМ в карточке, со значениями */
	card_meta: {
		type: Array as PropType<CardMetaItem[]>,
		default: () => ([]),
	},
	/** Все поля данного АРМ в карточке, со значениями */
	field_meta: {
		type: Object as PropType<CardMetaItem>,
		default: () => ({}),
	},
	/** (???) при показе в попапе например меняем z-index */
	show_in_popup: {},
	/** пропс используется например во время сохранения из списка */
	is_disabled: {
		type: Boolean,
		default: false,
	},
	is_new_record: {
		default: false,
	},
	isForceStatic: {
		type: Boolean,
		default: false,
	},
	brokenLinks: {
		type: Array,
		default: () => [],
	},
}


export const selectFieldsFromDatabase: UarmCtrlComponentMetaParam = {
	name: 'Колонки для показа',
	editType: 'selectFieldsFromDatabase',
	multiple: true,
	tip: `Перечисленные колонки/поля объекта, пришедшего в JSON, будут выведены через delimiter. См. types.ts`
};
